import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { IJob } from 'src/app/batches/jobs';
import { MIHttpClientService } from '../../mi-http-client.service';



@Injectable({
  providedIn: 'root',
})
export class BatchesWidgetService {

  public resetFiltersSubject = new BehaviorSubject<boolean>(false);
  resetFilters$ = this.resetFiltersSubject.asObservable();

  public callForDataSubject = new BehaviorSubject<boolean>(false);
  callForData$ = this.callForDataSubject.asObservable();

  constructor(
    private miClient: MIHttpClientService,
  ) {
  }

  getUnScheduledJobs(startDateFrom: string, startDateTo: string, downlineUserId: number): Observable<IJob[]> {
    const filters = [];

    if (startDateFrom) {
      filters.push(`startDateFrom=${startDateFrom}`);
    }
    if (startDateTo) {
      filters.push(`startDateTo=${startDateTo}`);
    }
    if(downlineUserId !== null) {
      filters.push(`userIds=${downlineUserId}`);
    }
    return this.miClient.get<any>('activityItems?isScheduled=0&isActive=true&' + filters.join('&'));
  }

}
